import { useLingui } from "@lingui/react/macro";

import { ErrorCode } from "../../../api";
import { apiErrorCode } from "../../../api/api-connector";
import { errorText } from "../../../app/error-text";

/**
 * Wording for a submitted code the backend rejected — the one failure both
 * enrolling and verifying phrase themselves. Anything else falls back to the
 * reason the error carries.
 */
export function useCodeErrorText() {
  const { t } = useLingui();

  return (error: unknown) =>
    apiErrorCode(error) === ErrorCode.MFA_INVALID_CODE
      ? t`That code was not correct. Please try again.`
      : errorText(error);
}
